export function notNullValues<V>(value: Nullable<V>): value is V {
    return value !== null
}
